import React from "react";
import { connect } from "react-redux";
import { Row, Col, Label, InputGroup, FormGroup, Input as RSInput } from "reactstrap";
import { pageActions } from "../../../../../store/actions/cms/page/page.action";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { deepClone } from "../../../../../helpers/objectHelper";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { templateHelper } from "../../../../areas/template/helpers/templateHelper";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import clsx from "clsx";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";
import { cmsActions } from "../../../../../store/actions/cms/cms.action";
import InputBase from "@material-ui/core/InputBase";
import { makeStyles, withStyles } from "@material-ui/core/styles";

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: ["-apple-system", "BlinkMacSystemFont", '"Segoe UI"', "Roboto", '"Helvetica Neue"', "Arial", "sans-serif", '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);
class FileUploaderSettings extends React.Component {
  state = {
    isMediaVaultOpen: false,
    invitations: [],
  };
  handleSoftUpdate = (element) => {
    const { dispatch, enviroment, page } = this.props;
    if (enviroment === sourceTypes.FORM) dispatch(formActions.updateFormElement(element));
    if (enviroment === sourceTypes.PAGE) dispatch(pageActions.updatePageElement(element, null, page));
    if (enviroment === sourceTypes.TEMPLATE) {
      const template = deepClone(this.props.template);
      const newTemplate = templateHelper.handleElementUpdates(element, template);
      dispatch(templateActions.softUpdate(newTemplate));
    }
  };

  toggle = (tabPane, tab) => {
    const newArray = this.state.activeTab.slice();
    newArray[tabPane] = tab;
    this.setState({
      activeTab: newArray,
    });
  };
  handleChange = (e, val, path) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedElement);
    let value = null;

    if (path == "data.allowedFiletypes") {
      value = e;
    } else if (val && val.hex !== undefined) {
      const { r, g, b, a } = val.rgb;
      value = `rgba(${r},${g},${b},${a})`;
    } else if (val) value = val;
    else if (e !== null) value = e.target.value;
    else return;

    if (path == "data.allowedFiletypes") {
      if (!element.data.allowedFiletypes) {
        element.data.allowedFiletypes = [];
      }
      if (element.data.allowedFiletypes.includes(value)) {
        element.data.allowedFiletypes.splice(element.data.allowedFiletypes.indexOf(value), 1);
      } else {
        element.data.allowedFiletypes.push(value);
      }
    } else if (names.length === 2) {
      element[names[0]][names[1]] = value;
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = value;
    } else if (names.length === 4) {
      element[names[0]][names[1]][names[2]][names[3]] = value;
    }
    this.handleSoftUpdate(element);
    console.log(element.data.allowedFiletypes);
  };

  toggleMediaVault = () => {
    this.setState({ isMediaVaultOpen: !this.state.isMediaVaultOpen });
  };
  render() {
    const selectStyles = {
      option: (styles, { data }) => {
        return {
          ...styles,
          fontSize: "12px",
          fontFamily: data.value,
          padding: "0 10px",
        };
      },
      container: (styles) => ({
        ...styles,
        minWidth: "100%",
        borderRight: "1px solid gainsboro",
      }),
      /*       control: styles => ({
                        borderWidth: '1px'
                    }), */
      singleValue: (styles, { data }) => {
        return {
          ...styles,
          fontSize: "12px",
          fontFamily: data.value,
        };
      },
    };
    const { selectedElement } = this.props;
    return (
      <div>
        <ListExpansion footer={false} icon="fa fa-image" description="GroupRegSettings" defaultExpanded={true}>
       {/*    <Row>
            <Col className="list-setting-item-title">
              <FormGroup style={{ width: "100%" }}>
                <Label htmlFor="text-label">
                  <SystemLabel name={`MinCountFiles`} />
                </Label>
                <RSInput
                  id="text-label"
                  type="number"
                  min={0}
                  max={this.props.form.pages}
                  autoComplete="jirango-nofill"
                  value={selectedElement.data.minFiles ? selectedElement.data.minFiles : 0}
                  onChange={(e) => this.handleChange(e, null, `data.minFiles`)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col className="list-setting-item-title">
              <FormGroup style={{ width: "100%" }}>
                <Label htmlFor="text-label">
                  <SystemLabel name={`MaxCountFiles`} />
                </Label>
                <RSInput
                  id="text-label"
                  type="number"
                  min={0}
                  max={this.props.form.pages}
                  autoComplete="jirango-nofill"
                  value={selectedElement.data.maxFiles ? selectedElement.data.maxFiles : 0}
                  onChange={(e) => this.handleChange(e, null, `data.maxFiles`)}
                />
              </FormGroup>
            </Col>
          </Row> */}
          <Row>
            <Col className="list-setting-item-title">
              <FormGroup style={{ width: "100%" }}>
                <Label htmlFor="text-label">
                  <SystemLabel name={`AllowedFileTypes`} />
                </Label>
                <MultipleSelect
                  block={() => this.props.dispatch(cmsActions.blockDeselect(true))}
                  unBlock={() => this.props.dispatch(cmsActions.blockDeselect(false))}
                  options={selectedElement.data.allowedFiletypes}
                  onChange={(type) => this.handleChange(type, null, `data.allowedFiletypes`)}
                />
              </FormGroup>
            </Col>
          </Row>
        </ListExpansion>
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { enviroment } = state.cms;
  let selectedElement = null;
  if (enviroment === sourceTypes.FORM) selectedElement = state.form.selectedElement;
  if (enviroment === sourceTypes.PAGE) selectedElement = state.page.selectedElement;
  if (enviroment === sourceTypes.TEMPLATE) selectedElement = state.template.selectedElement;
  return {
    enviroment: enviroment,
    template: state.template.template,
    form: state.form,
    page: state.page,
    selectedElement: selectedElement,
    cms: state.cms,
  };
}
export default connect(mapStateToProps)(FileUploaderSettings);

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const OPTIONS = [
  { label: "Pdf", value: ".pdf," },
  { label: "Powerpoints", value: ".ppt," },
  { label: "Documents", value: ".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .txt," },
  { label: "Images", value: "image/*," },
  { label: "Excel", value: ".xls, .xlsx," },
  { label: "Audio", value: ".mp4, .mp3," },
];
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function MultipleSelect({ options = [], onChange, block, unBlock }) {
  return (
    <div>
      <FormControl style={{ width: 280 }}>
        <Select
          onOpen={() => block()}
          labelId="demo-mutiple-chip-label"
          id="demo-mutiple-chip"
          multiple
          value={options}
          input={<BootstrapInput />}
          renderValue={() => (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {options.map((value) => (
                <Chip key={value} label={OPTIONS.find((o) => o.value == value)?.label} style={{ margin: 2 }} />
              ))}
            </div>
          )}
          MenuProps={MenuProps}
        >
          {OPTIONS.map((name) => (
            <MenuItem
              onClick={(e) => {
                onChange(name.value);
                setTimeout(() => unBlock(), 1500);
              }}
              key={name.label}
              value={name.value}
            >
              <SystemLabel name={name.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
